module.exports = "/images/sophia-stories.webp?1b500066b984501858de11c89f1375dc";